module.exports = __webpack_public_path__ + "static/media/RadiusAgentNewLogoNoBar.c50e9261.svg";